import { createFileRoute } from '@tanstack/react-router'
import { SettingsPlaceholderPage } from '@/pages/settings/settings-placeholder-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/settings/webhooks')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.Webhooks}>
      <WebhooksPage />
    </WorkspaceEntitlementGate>
  ),
})

function WebhooksPage() {
  return <SettingsPlaceholderPage page="settingsWebhooks" />
}
